import React, { useContext, useRef } from 'react';
import { useEffect, useState } from "react";
import { selfieInsArrow } from "../../../images/btnIcons";
import LanguageTranslater from "../../HOC/LanguageTranslater";
import { isIOSDevice } from "../../../utils/getDevice";
import * as faceapi from 'face-api.js';
import { compress, getBase64TypeAndString } from '../../../utils/compressor';
import { getApiData } from '../../../api/api';
import { generateCorrelationId } from '../../../utils/correlationId';
import AxiosRequest from '../../../utils/axios';
import SubmitPhoto from '../PhotoVerification/SubmitPhoto/SubmitPhoto';
import { isNewUI, isPODPosv } from '../../../utils/handleProgress';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import DotsLoader from '../../Loader/DotsLoader/DotsLoader';
import SelfieErrorComponent from '../SelfieErrorComponent/SelfieErrorComponent';
import VideoSubmission from '../VideoSubmission/VideoSubmission';
import "./LiveSelfie.css";
import AllowAccessIOS from '../AllowAccessIOS/AllowAccessIOS';
import AllowAccessAndroid from '../AllowAccessAndroid/AllowAccessAndroid';
import "../../POSV_New_Ui/PhotoVerification/PhotoVerification.css"
import { SpeakerContext } from '../../../context/SpeakerContext';
import { CAPS_Y } from '../../../utils/constants';

const axios = new AxiosRequest().getClient()

const LiveSelfie = ({ translate }) => {
    const { loadingFacedetectionModel } = useContext(SpeakerContext)
    const videoRef = useRef(null);
    let faceDectetcionInt = null;
    let selfieCaptureInt = null;

    const SELFIE_CATEGORIES = {
        SELFIE: "selfie",
        SELFIE_LIVE: "selfie_live"
    }
    const category = localStorage.getItem("category")
    const REQUIRED_FRAMES = category === SELFIE_CATEGORIES.SELFIE_LIVE ? 10 : 1;
    const FACE_IN_FRAME_TIME_REQUIRED = 7;
    const isVideoPosv = localStorage.getItem("isVideoPosv")
    const simplifiedJourney = localStorage.getItem("simplifiedJourney")
    const tinyFaceDetectionModel = localStorage.getItem("tinyFaceDetectionModel") === CAPS_Y

    const router = useHistory()

    const [selfieErrorMsg, setSelfieDetectionMsg] = useState("");
    const [framesLeft, setFramesLeft] = useState(REQUIRED_FRAMES);
    const [startCapturing, setStartCapturing] = useState(false)
    const [gettingFace, setGettingFace] = useState(false);
    const [pictureTaken, setPictureTaken] = useState(false);
    const [picture, setPicture] = useState('');
    const [pictureType, setPictureType] = useState('');
    const [faceInFrameTime, setFaceInFrameTime] = useState(0);
    const [takeSelfieCount, setTakeSelfieCount] = useState(1);
    const [aiImagesDetails, setAiImagesDetails] = useState(null)
    const [aiStatusCode, setAiStatusCode] = useState(null)
    const [selfieSubmitErr, setSelfieSubmitErr] = useState(false);
    const [selfieSubmitErrMessage, setSelfieSubmitErrMessage] = useState(false);
    const [showSubmitSelfieButton, setShowSubmitSelfieButton] = useState(localStorage.getItem("category") == "selfie" ? true : false)
    const [checkingLiveness, setCheckingLiveness] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [loadingMsg, setLoadingMsg] = useState(false);
    const [hasPermission, setHasPermission] = useState('')
    const [coords, setCoords] = useState({})
    const [showAutoRedirectPage, setShowAutoRedirectPage] = useState(false);
    const [permissionDenied, setPermissionDenied] = useState("")

    const getIosWrapperClass = () => {
        return isIOSDevice() ? 'is-selfie-wrapper' : ''
    }

    useEffect(() => {
        sessionStorage.setItem("reloadAfterSelfie", "Y")
        checkCamera()
        startVideo()
        return () => {
            clearInterval(faceDectetcionInt)
            clearInterval(selfieCaptureInt)
        }
    }, [])

    const checkCamera = async () => {
        const permissionStatus = await navigator?.permissions?.query({
            name: "camera",
        });
        console.log(permissionStatus);
        setPermissionDenied(permissionStatus.state !== "granted")
    };

    useEffect(() => {
        if (faceInFrameTime === 0) {
            setFramesLeft(REQUIRED_FRAMES)
            setStartCapturing(false)
            clearInterval(selfieCaptureInt)
        }
        if (faceInFrameTime === FACE_IN_FRAME_TIME_REQUIRED) {
            setStartCapturing(true)
        }
    }, [faceInFrameTime])

    useEffect(() => {
        if (startCapturing) {
            console.log({ framesLeft })
            const imageArr = []
            let imageType = "";
            selfieCaptureInt = setInterval(async () => {
                const image = extractPhotoFromVideo();
                await compress(image)
                    .then(async (res) => {
                        const { byteArray } = res;
                        const { type, imgString } = getBase64TypeAndString(byteArray);

                        imageArr.push(imgString);
                        imageType = type;
                        setFramesLeft((prev) => (prev - 1))
                        setPictureType(type)
                        if (imageArr.length === REQUIRED_FRAMES) {
                            console.log({ imageArr })
                            clearInterval(selfieCaptureInt);
                            clearInterval(faceDectetcionInt)
                            closeWebcam();
                            if (category === SELFIE_CATEGORIES.SELFIE) {
                                setPictureTaken(true)
                                setPicture(`data:image/${imageType};base64,` + imgString);
                            } else {
                                sendAiSelfieRequest(imageArr, imageType)
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 150)
        }
    }, [startCapturing])

    const extractPhotoFromVideo = () => {
        const video = document.getElementById("video");
        const canvas = document.createElement("canvas");
        canvas.width = 359;
        canvas.height = 464;
        const context = canvas.getContext("2d");
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        let imageCaptured = canvas.toDataURL("image/jpeg", 1.0);
        // console.log("Capture Image....", imageCaptured)
        return imageCaptured;
    };


    const startVideo = async () => {
        setLoading(true)
        setLoadingMsg("Please wait while we setup camera for you")
        setPicture('')
        setPictureTaken(false)
        if(loadingFacedetectionModel) {
            const isTinyFaceDetectionModel = localStorage.getItem("tinyFaceDetectionModel") === CAPS_Y;
            const detector = isTinyFaceDetectionModel ? 'tinyFaceDetector' : 'ssdMobilenetv1'
            await faceapi.nets[detector].loadFromUri('/models');
        }
        navigator.mediaDevices
            .getUserMedia({ video: { width: 240, height: 240, facingMode: "user" } })
            .then((stream) => {
                videoRef.current.srcObject = stream;
            })
            .catch((err) => {
                console.log('Error accessing webcam:', err)
                setLoading(false)
            });
    };

    const restartVideo = () => {
        window.location.reload();
    }

    const handleVideoOnPlay = async () => {
        const video = videoRef.current;

        const canvas = faceapi.createCanvasFromMedia(video);
        document.body.appendChild(canvas);
        const displaySize = { width: video.width, height: video.height };
        faceapi.matchDimensions(canvas, displaySize);
        faceDectetcionInt = setInterval(async () => {
            try {
                const isTinyFaceDetectionModel = localStorage.getItem("tinyFaceDetectionModel") === CAPS_Y;
                const method = isTinyFaceDetectionModel ? faceapi.detectAllFaces(video, new faceapi.TinyFaceDetectorOptions()) : faceapi.detectAllFaces(video)
                const requiredScore = isTinyFaceDetectionModel ? 0.7 : 0.9
                const detections = await method;
                console.log({detections})
                if (detections?.length === 1) {
                    const prediction = detections[0];
                    const matchScore = prediction._score
                    const boxWidth = prediction._box._width
                    const boxXCoord = prediction._box._x
                    const boxYCoord = prediction._box._y
                    if (matchScore > requiredScore) {
                        setSelfieDetectionMsg("")
                        setGettingFace(true)
                        if (boxWidth < 76) {
                            setFaceInFrameTime(0)
                            setGettingFace(false)
                            setSelfieDetectionMsg("Move Closer")
                        } else if (boxYCoord > 95 || boxYCoord < 70 || boxXCoord < 55 || boxXCoord > 95) {
                            setFaceInFrameTime(0)
                            setGettingFace(false);
                            setSelfieDetectionMsg("Center your face")
                        } else {
                            setGettingFace(true)
                            setSelfieDetectionMsg("Good, Hold still")
                            setFaceInFrameTime((prev) => (prev + 1))
                        }
                    } else {
                        setFaceInFrameTime(0)
                        setSelfieDetectionMsg("Please don't cover your face")
                        setGettingFace(false)
                    }
                } else {
                    console.log("multiple face detected")
                    setFaceInFrameTime(0)
                    setGettingFace(false)
                }
            } catch (error) {
                console.log({ error })
            } finally {
                setLoading(false);
            }
        }, 100);
    };

    const checkLocationPermission = async () => {
        const permissionStatus = await navigator?.permissions?.query({
            name: "geolocation",
        });
        const hasPermission = permissionStatus?.state;
        getLocation();
        setHasPermission(hasPermission)
        return hasPermission;
    };

    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            // console.log("Geolocation is not supported by this browser.");
        }
    };

    const showPosition = (position) => {
        setCoords({
            lat: position.coords.latitude,
            long: position.coords.longitude,
        });
    };

    const sendAiSelfieRequest = async (imageArray, imageType) => {
        setCheckingLiveness(true)
        setLoadingMsg("Checking Liveness...")
        let { url, body } = getApiData("validateCustomerSelfie");
        body.request.header.correlationId = generateCorrelationId();
        body.request.payload.planCode = localStorage.getItem("planCode");
        body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
        body.request.payload.multipleImageFile = imageArray;
        body.request.payload.sessionId = localStorage.getItem("sessionId");
        body.request.payload.sourceId = localStorage.getItem("source");
        body.request.payload.eventType = "click";
        body.request.payload.journeyBy = localStorage.getItem("journeyBy");

        body.request.payload.fileExtension = imageType;
        body.request.payload.iosStatus = isIOSDevice() ? true : false;
        body.request.payload.authToken = "";
        body.request.payload.takeSelfieCount = takeSelfieCount;

        try {
            const response = await axios.post(url, body);
            const byteselfiarray = response.data.response.payload.selfieByteArray;
            const statusCode = response.data.response.msgInfo.msgCode;
            const livelinessMsgs = response.data.response.payload.businessMsg
            let imageFromApi =
                byteselfiarray && byteselfiarray.length
                    ? byteselfiarray
                    : imageArray[0];
            setAiStatusCode(statusCode)

            if (statusCode == 200) {
                setPicture(`data:image/${imageType};base64,` + imageFromApi);
                setPictureTaken(true)
                setAiImagesDetails({
                    aiImage: imageFromApi,
                    aiImgArray: imageArray,
                    aiImageType: imageType,
                    aiImageCaptured: true,
                    showSubmitSelfieButton: true,
                    showTakeSelfieButton: true,
                    livelinessMsgs
                });
                setShowSubmitSelfieButton(true)
                closeWebcam();
            } else if (statusCode == 400) {
                setAiImagesDetails({
                    aiImage: imageFromApi,
                    aiImgArray: imageArray,
                    aiImageType: imageType,
                    aiImageCaptured: true,
                    showSubmitSelfieButton: false,
                    showTakeSelfieButton: true,
                    pictureTaken: true,
                    picture: `data:image/${imageType};base64,` + imageFromApi,
                    livelinessMsgs
                });
                setPicture(`data:image/${imageType};base64,` + imageFromApi);
                setPictureTaken(true);
                setShowSubmitSelfieButton(true)
                closeWebcam();
            } else {
                setAiImagesDetails({
                    aiImage: imageFromApi,
                    aiImgArray: imageArray,
                    aiImageType: imageType,
                    aiImageCaptured: true,
                    showSubmitSelfieButton: false,
                    showTakeSelfieButton: true,
                    pictureTaken: true,
                    picture: `data:image/${imageType};base64,` + imageFromApi,
                    livelinessMsgs
                });
                setPicture(`data:image/${imageType};base64,` + imageFromApi);
                setPictureTaken(true)
                setShowSubmitSelfieButton(false)
                closeWebcam();
            }
        } catch (err) {
            startVideo()
            setGettingFace(false)
            setStartCapturing(false)
        } finally {
            setTakeSelfieCount((prev) => (prev + 1))
            setCheckingLiveness(false)
        }
    };

    const submitSelfie = () => {
        compress(picture)
            .then(async (res) => {
                const { byteArray } = res;
                const { type, imgString } = getBase64TypeAndString(byteArray);
                sumbitPostRequest(imgString, type);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const sumbitPostRequest = async (imgString = "", type = "") => {
        if (!imgString) {
            if (isVideoPosv === "Y") {
                router.push(`/video-verification?page=Product`);
            } else {
                router.push(`/customer_feedback?page=Product`);
            }
        } else if (category === SELFIE_CATEGORIES.SELFIE) {
            const { url, body } = getApiData("verifyCustomerImage");
            body.request.payload.imageFile = imgString;
            body.request.payload.fileExtension = type;
            body.request.payload.iosStatus = isIOSDevice().toString();
            body.request.payload.faceDetected = false;
            body.request.payload.oldSelfieOnNewUI = "N";
            body.request.payload.journeyBy = localStorage.getItem("journeyBy");
            if (simplifiedJourney == "y") {
                body.request.payload.simplifiedJourney = simplifiedJourney;
            } else {
                body.request.payload.simplifiedJourney = "n";
            }
            postImageHandler(url, body);
        } else {
            const { lat, long } = coords;
            let { url, body } = getApiData("validateCustomerSelfie");
            body.request.header.correlationId = generateCorrelationId();
            body.request.payload.planCode = localStorage.getItem("planCode");
            body.request.payload.posvRefNumber =
                localStorage.getItem("posvRefNumber");
            body.request.payload.multipleImageFile = [imgString];
            body.request.payload.eventType = "submit";
            body.request.payload.journeyBy = localStorage.getItem("journeyBy");

            body.request.payload.fileExtension = type;
            body.request.payload.iosStatus = isIOSDevice() ? true : false;
            body.request.payload.lat = lat;
            body.request.payload.longitude = long;
            body.request.payload.selfieTimestamp = Date.now();
            body.request.payload.faceDetected = true;
            if (simplifiedJourney == "y") {
                body.request.payload.simplifiedJourney = simplifiedJourney;
            } else {
                body.request.payload.simplifiedJourney = "n";
            }
            postImageHandler(url, body);
        }
    };

    const postImageHandler = async (url, body) => {
        setLoading(true);
        setSelfieSubmitErr(false)
        setSubmitting(true)
        setLoadingMsg("wait_submitting_photo")
        try {
            const response = await axios.post(url, body);
            if (
                response.data &&
                response.data.response &&
                !response.data.response.payload.isImageValid
            ) {
                const message = response.data.response.payload.businessMsg
                    ? response.data.response.payload.businessMsg
                    : "Due to technical issue we couldn’t save the photo!";

                setSelfieSubmitErr(true)
                setSelfieSubmitErrMessage(message)
            } else {
                const path = response.data.response.payload.qstCatName.toLowerCase();
                if (!path) {
                    router.push("/generate_otp");
                    return;
                }
                localStorage.setItem("path", path);
                if (simplifiedJourney?.toLocaleLowerCase() == "y") {
                    if (isNewUI() && !isPODPosv()) {
                        setShowAutoRedirectPage(true)
                        setSubmitting(false);
                        setLoadingMsg("")
                        setLoading(false)
                        return;
                    } else {
                        if (isVideoPosv === "Y") {
                            router.push(`/video-verification`);
                        } else {
                            router.push(`/customer_feedback`);
                        }
                    }
                }
                else {
                    console.log("inside non simplified")
                    if (isNewUI() && !isPODPosv()) {
                        console.log("inside non simplified New UI ++")
                        setShowAutoRedirectPage(true)
                        setSubmitting(false);
                        setLoadingMsg("")
                        setLoading(false)
                        return
                    } else {
                        if (isVideoPosv === "Y") {
                            console.log("inside non simplified OLD UI -- vposv")
                            router.push(`/video-verification?page=${path}`);
                        } else {
                            console.log("inside non simplified OLD UI -- sposv")
                            router.push(`/customer_feedback?page=${path}`);
                        }
                    }
                }
            }
        } catch (err) {
            setSelfieSubmitErr(true);
            selfieSubmitErrMessage("Due to technical issue we couldn’t save the photo!")
        } finally {
            setSubmitting(false);
            setLoadingMsg("")
            setLoading(false)
        }
    };


    const redirectToPage = (route) => {
        let path = localStorage.getItem('path')
        if (simplifiedJourney?.toLocaleLowerCase() == 'y') {
            if (isNewUI()) {
                let p = isVideoPosv === "Y" ? '/video-consent' : '/generate_otp'
                router.push(p)
            } else {
                if (isVideoPosv === "Y") {
                    router.push(`/video-verification`);
                } else {
                    router.push(`/customer_feedback`);
                }
            }

        }
        else {
            if (isNewUI()) {
                let p = isVideoPosv === "Y" ? '/video-consent' : '/generate_otp'
                router.push(p)
            } else {
                if (isVideoPosv === "Y") {
                    router.push(`/video-verification?page=${path}`);
                } else {
                    router.push(`/customer_feedback?page=${path}`);
                }
            }
        }
    }


    const closeWebcam = () => {
        const video = document.getElementById("video");
        setTimeout(function () {
            if (video && video.srcObject) {
                video.pause();
                video.srcObject.getVideoTracks()[0].stop();
            }
        }, 100);
    };

    if (permissionDenied) {
        return isIOSDevice() ? <AllowAccessIOS startVideo={restartVideo} /> : <AllowAccessAndroid startVideo={restartVideo} />
    }

    return (
        <>
            {(loading || checkingLiveness || submitting) && <DotsLoader msg={translate(loadingMsg)} />}
            {showAutoRedirectPage && (
                <VideoSubmission
                    redirectionMsg={"feedback"}
                    messageTxt={translate("Photo_submitted")}
                    redirectToPage={redirectToPage}
                />
            )}
            {selfieSubmitErr && (
                <SelfieErrorComponent
                    selfieSubmitErrMessage={selfieSubmitErrMessage}
                    retake={restartVideo}
                />
            )}
            {pictureTaken && !selfieSubmitErr && (
                <SubmitPhoto
                    photo={picture}
                    retake={restartVideo}
                    submitSelfie={submitSelfie}
                    showSubmitSelfieButton={showSubmitSelfieButton}
                    livelinessErr={category === SELFIE_CATEGORIES.SELFIE_LIVE && aiStatusCode != 200}
                    errMsg={aiImagesDetails?.livelinessMsgs}
                    selfieSubmitErr={selfieSubmitErr}
                />
            )}
            {!pictureTaken && (
                <div className="photoVerification">
                    <div className="photoVerificationInner">
                        <h6>{translate("Position_face_inside_circle")}</h6>
                        <p>{translate("bright_light_with_plain_background")}</p>
                        <div className={`cameraFrame ${getIosWrapperClass()}`}>
                            <div
                                className={
                                    !pictureTaken
                                        ? gettingFace
                                            ? "videoWrapper cicleGreen"
                                            : "videoWrapper cicleRed"
                                        : "videoWrapper"
                                }
                            >
                                <video
                                    width={359.48}
                                    height={464}
                                    id="video"
                                    muted
                                    autoPlay
                                    ref={videoRef}
                                    onPlay={handleVideoOnPlay}
                                    playsInline
                                />
                                <img
                                    className="selfie-ins-arrow"
                                    src={selfieInsArrow}
                                    alt="arrow_icn"
                                />
                            </div>
                        </div>
                        <div className={`new_ui selfie_err_msgs ${getIosWrapperClass()}`}>
                            <p>{translate(selfieErrorMsg)}</p>
                            {category === SELFIE_CATEGORIES.SELFIE_LIVE &&
                                framesLeft > 0 &&
                                gettingFace && (
                                    <p>
                                        Capturing... <span>{framesLeft}</span>{" "}
                                    </p>
                                )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default LanguageTranslater(LiveSelfie);